import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Auth0Wrapper } from '@lib/auth/auth0.tsx'
import { AxiosApiProvider } from '@lib/api/axios-provider.tsx'
import { queryClient } from '@lib/api/query-client-provider.ts'
import { AuthenticatedRouterProvider } from '@/routes/-router-provider.tsx'

import './globals.css'

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Auth0Wrapper>
            <AxiosApiProvider>
                <QueryClientProvider client={queryClient}>
                    <AuthenticatedRouterProvider/>
                </QueryClientProvider>
            </AxiosApiProvider>
        </Auth0Wrapper>
    </StrictMode>,
)
